export const BOOK = '/book'
export const USERS = '/users'
export const ROUTES = '/routes'
export const SIGNIN = '/signin'
export const PRICES = '/prices'
export const LOGISTIC = '/logistic'
export const PLAYGROUND = '/playground'
export const WEBSITE_BOOKINGS = '/website-bookings'
export const BLACKLIST = '/blacklist'



// WEBPACK FOOTER //
// ./src/constants/urls.js